import { useContext } from "react";
import { Button } from "shared/Components/button";
import { OutlineButton } from "shared/Components/outlineButton";
import { LoaderContext } from "../Context/EditAndLoaderContext";
import { globalVariables } from "helper/globalVariables";
import { edit } from "helper/icons";
import { SWITCH_ROLE } from "./constants";

export const SubmitButton = ({
  handleCancel,
  handelSave,
  selectedTab = "",
  setEditable,
  isEditable,
}) => {
  const onCancel = () => {
    setEditable(false);
    handleCancel();
  };

  const isLoading = useContext(LoaderContext);
  return isEditable || selectedTab === SWITCH_ROLE ? (
    <div className="hidden md:flex lg:flex md:mr-[24px] lg:mr-20">
      <OutlineButton
        onClick={onCancel}
        width={"w-44"}
        label={"Cancel Changes"}
      />
      <div className="ml-3" />
      <Button
        onClick={handelSave}
        width={"w-44"}
        label={"Save Changes"}
        disabled={isLoading}
      />
    </div>
  ) : (
    <div className="hidden md:flex lg:flex md:mr-[24px] lg:mr-20">
      <Button
        onClick={() => setEditable(!isEditable)}
        width={"w-32"}
        label={globalVariables.edit}
        icon={edit}
        prefix={false}
      />
    </div>
  );
};
